import styled, { css } from 'styled-components';

export const StartStepContainer = styled.div`
    justify-content: center;
    align-items: center;
    display: flex;
    height: 100%;
    padding: 32px 16px 16px 16px;

    ${(props) => props.theme.breakpointTo.sm} {
        width: 100%;
    }

    .title {
        text-align: center;
        margin-top: 20px;
        margin-bottom: 0;

        ${(props) => props.theme.breakpointTo.md} {
            margin-top: 0;
        }
    }

    .content-wrapper {
        display: flex;
        width: 100%;
    }

    .logo-container {
        position: relative;
        ${(props) => props.theme.breakpointTo.sm} {
            display: flex;
            flex-direction: column;
        }
    }

    .language-selector {
        position: absolute;
        right: 0;
        bottom: 0;
        max-width: 160px;

        ${(props) => props.theme.breakpointTo.sm} {
            position: static;
            margin-left: auto;
            margin-bottom: 20px;
        }
    }

    .logo-wrapper {
        max-width: 134px;
        max-height: 27px;
        margin: 0 auto;
    }

    .verification-profile-autocomplete {
        margin-bottom: 24px;
        width: 246px;

        ${(props) => props.theme.breakpointTo.md} {
            margin-bottom: 20px;
        }

        ${(props) => props.theme.breakpointTo.sm} {
            width: 100%;
        }
    }

    .main-content-container {
        max-width: 872px;
        display: flex;
        flex-direction: column;
        gap: 32px;
        margin: auto;

        ${(props) => props.theme.breakpointTo.sm} {
            width: 100%;
            height: 100%;
            gap: 24px;
        }

        .carousel {
            min-height: 260px;
        }

        .description {
            ${(props) => props.theme.typography.text};
            text-align: center;
            margin-bottom: 46px;

            ${(props) => props.theme.breakpointTo.md} {
                margin-bottom: 68px;
            }

            ${(props) => props.theme.breakpointTo.xs} {
                margin-bottom: 20px;
            }
        }

        .button {
            min-width: 264px;

            ${(props) => props.theme.breakpointTo.sm} {
                width: 100%;
            }
        }

        .copy-link-title {
            margin-top: 3px;

            & > label {
                ${(props) => props.theme.typography.textBold};
                text-align: left;
            }

            .MuiInputBase-root {
                background-color: ${(props) => props.theme.palette.primaryA7};
            }
        }

        .footer-container {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            gap: 32px;

            ${(props) => props.theme.breakpointTo.sm} {
                gap: 16px;
                align-items: center;
                margin-top: auto;
            }

            .country-autocomplete {
                min-width: 245px;

                ${(props) => props.theme.breakpointTo.sm} {
                    min-width: 272px;
                }

                ${(props) => props.theme.breakpointTo.xs} {
                    width: 100%;
                }
            }

            .MuiInputBase-root {
                background-color: ${(props) => props.theme.palette.primaryA7};
            }

            label {
                color: ${(props) => props.theme.palette.textLight};
            }
        }
    }

    .links-container {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 24px;

        .card {
            min-width: 424px;
            min-height: 120px;
            padding: 20px;
            border-radius: 8px;
            gap: 20px;
            background-color: ${(props) => props.theme.palette.secondaryA10};
        }
    }

    .requirements-container {
        display: flex;
        flex-direction: column;
        gap: 16px;

        & > span {
            min-height: 44px;
        }
    }
`;

export const CardsContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    gap: 24px;
`;

export const ConfirmationContainer = styled.div`
    ${(props) => props.theme.typography.smallText};
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 20px;

    ${(props) => props.theme.breakpointTo.sm} {
        flex-direction: column;
        align-items: center;
        gap: 16px;
    }

    ${(props) => props.theme.breakpointTo.xs} {
        align-items: center;
    }

    div {
        display: flex;
        align-items: center;
    }

    .MuiTypography-root {
        margin-left: 4px;
        font-size: 14px;
    }
`;

export const LogoWrapper = styled.div`
    width: 150px;
    min-height: 80px;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    ${({ theme }) =>
        theme.components.sideMenu.backgroundColor &&
        css`
            background-color: ${() => theme.components.sideMenu.backgroundColor};
        `}
`;
